<ng-container>
    <div mat-dialog-title>
        <h2>{{"restaurant.Set Exception Rule (Guests Tags)" | translate}}</h2>
        <button mat-icon-button class="close" (click)="openConfirmDialog()">
            <mat-icon class="pop-close">close</mat-icon>
        </button>
    </div>
    <div *ngIf='loading' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <mat-dialog-content class="pt-0 pb-0" *ngIf="!loading">
        <div class="mat-dialog-body">
            <p class="info">{{"restaurant.Choose all guests tags to be excluded from cancellation fees" | translate}}
            </p>
            <div class="fields-group mt-3">
                <div class="circle-checkboxes">
                    <ng-container *ngIf="allTags">
                        <ng-container>
                            <mat-checkbox *ngFor="let tag of allTags; index as index" [checked]="tag.isSelected"
                                (change)="onChangeEventFunc(tag, $event)">
                                {{tag.name}}
                            </mat-checkbox>
                        </ng-container>
                    </ng-container>
                </div>
            </div>

            <div class="data-empty" *ngIf="!allTags.length">
                <p>{{"general.No Data Found" | translate}}</p>
              </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
        <!-- [disabled]="loading" [class.loading]="loading" *ngIf="isUpdate" -->
        <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
            {{"forms.Save" | translate}}
        </button>
    </mat-dialog-actions>
</ng-container>
